import React from "react";
import styles from "./EWallet.module.scss";
import GRADES from "../../constants/grades";
import { library, icon, toHtml } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(faChevronRight)

function CaretRightIcon() {
  return <FontAwesomeIcon icon="chevron-right" />;
}

function EWallet(params: any) {
  return (
    <div className={`${styles.EWallet} ${params.payment ? styles.hover : ''}`} id="eWallet-tile" key={params.item.id}>
      <div className={styles.firstRow}>
        <div className={styles.nameLabel}>
          {(params.item.studentFirstName === "" && params.item.studentLastName === "") 
          ? `${params.item.teacherLastName}${(params.item.teacherFirstName) ? `, ${params.item.teacherFirstName}` : ""}` 
          : `${params.item.studentLastName}, ${params.item.studentFirstName}` 
          }
        </div>
        <div className={styles.moneyLabel}>
          $
          {params.item.amount.toFixed(2)}
        </div>
      </div>
      <div className={`${styles.whiteLabel} ${styles.gradeLabel}`}>
        Grade:
        {" "}
        { GRADES.map((item) => (item.value === params.item.grade.toLowerCase() ? item.tile : "")) }
      </div>
      <div className={styles.bottomRow}>
        <div className={`${styles.whiteLabel} ${styles.teacherLabel}`}>
          Teacher:
          {" "}
          {params.item.teacherFirstName}
          {" "}
          {params.item.teacherLastName}
        </div>
        <div className={`${params.payment ? styles.chevron : styles.disable}`} >
          <CaretRightIcon/>
        </div>
      </div>
    </div>
  );
}

export default EWallet;
